import { render, staticRenderFns } from "./importPopup.vue?vue&type=template&id=64f844a7&scoped=true&"
import script from "./importPopup.vue?vue&type=script&lang=js&"
export * from "./importPopup.vue?vue&type=script&lang=js&"
import style0 from "./importPopup.vue?vue&type=style&index=0&id=64f844a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f844a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64f844a7')) {
      api.createRecord('64f844a7', component.options)
    } else {
      api.reload('64f844a7', component.options)
    }
    module.hot.accept("./importPopup.vue?vue&type=template&id=64f844a7&scoped=true&", function () {
      api.rerender('64f844a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mass/scriptLibrary/importPopup.vue"
export default component.exports